import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAdminAuth } from "./AdminAuthContext";

export default function AdminLogin() {
  const { login, user, loading } = useAdminAuth();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  if (loading) return <div className="min-h-screen flex items-center justify-center text-white bg-black">Cargando...</div>;
  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await login(email.trim().toLowerCase(), pw);
      nav("/admin", { replace: true });
    } catch (e2) {
      setErr(e2?.response?.data?.detail || "Error de autenticación");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-6">
      <form onSubmit={onSubmit} data-testid="admin-login-form" className="w-full max-w-md border border-white/15 bg-[#0a0a0c] p-8 space-y-5">
        <img src="/asirox-logo.png" alt="Asirox" className="h-12 w-auto mb-6"/>
        <h1 className="font-heading text-3xl text-white font-bold">Backoffice</h1>
        <p className="text-white/60 text-sm">Acceso restringido al equipo Asirox.</p>
        <div>
          <label className="text-xs uppercase tracking-wider text-white/60">Email</label>
          <input data-testid="admin-login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full mt-2 bg-white/5 border border-white/15 px-4 py-3 text-white outline-none focus:border-[#ff9c00]"/>
        </div>
        <div>
          <label className="text-xs uppercase tracking-wider text-white/60">Contraseña</label>
          <input data-testid="admin-login-password" type="password" required value={pw} onChange={(e) => setPw(e.target.value)} className="w-full mt-2 bg-white/5 border border-white/15 px-4 py-3 text-white outline-none focus:border-[#ff9c00]"/>
        </div>
        {err && <p data-testid="admin-login-error" className="text-red-400 text-sm">{err}</p>}
        <button data-testid="admin-login-submit" type="submit" disabled={busy} className="w-full bg-[#ff9c00] text-black font-bold py-3 hover:bg-[#ffb133] disabled:opacity-50">
          {busy ? "Accediendo..." : "Entrar"}
        </button>
      </form>
    </div>
  );
}
